import { render, staticRenderFns } from "./AcordosPerformance.vue?vue&type=template&id=5c0fe982&scoped=true"
import script from "./AcordosPerformance.vue?vue&type=script&lang=js"
export * from "./AcordosPerformance.vue?vue&type=script&lang=js"
import style0 from "./AcordosPerformance.vue?vue&type=style&index=0&id=5c0fe982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fe982",
  null
  
)

export default component.exports